import React from 'react';
import './DotDigits.scss';

interface DotDigitsProps {
    children: React.ReactNode;
    size: number;
    className?: string;
}
function DotDigits({
    children,
    size,
    className,
}: DotDigitsProps): React.ReactElement {
    return (
        <span
            className={['rd-digits', className].filter(Boolean).join(' ')}
            style={{ fontSize: `${size}px` }}
        >
            {children}
        </span>
    );
}

DotDigits.defaultProps = { className: undefined };

export default DotDigits;
